import React, { useEffect } from 'react';
import { Home } from './pages/Home';
import { ICON_URL } from './data/site';
const TITLE = 'David Moceri | Marketer, Motivator & Mentor — Marketing, Automation & AI';
const DESCRIPTION = 'David Moceri helps business owners streamline the work, grow revenue and believe in what’s possible — 30 years in marketing, deep in automation and AI. Book David to speak or work with him.';
function setHeadTag(selector: string, create: () => HTMLElement, apply: (el: HTMLElement) => void) {
  let el = document.head.querySelector<HTMLElement>(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  apply(el);
}
export function App() {
  useEffect(() => {
    document.title = TITLE;
    document.documentElement.lang = 'en';
    setHeadTag('meta[name="description"]', () => Object.assign(document.createElement('meta'), {
      name: 'description'
    }), el => el.setAttribute('content', DESCRIPTION));
    setHeadTag('link[rel="icon"]', () => Object.assign(document.createElement('link'), {
      rel: 'icon'
    }), el => el.setAttribute('href', ICON_URL));
  }, []);
  return <Home data-id="element-0" data-mp="3mjg9hk8s47lo" />;
}